import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";




const json = {
    1: {
        unit: 'Unit 6',
        id: 'WB4-V2-U6-P44-E1',
        audio: '',
        video: '',
        component: UI,
        titleImage: '',
        question: [
        ],
        questionImage: [
            [
                { url: 'img/FriendsPlus/Page44/E1/1.jpg' },
            ],
        ]
    },

    2: {
        // Exercise num
        unit: 'Unit 6',
        id: 'WB4-V2-U6-P44-E2',
        audio: "",
        video: "",
        component: T6,
        exerciseKey: "img/FriendsPlus/Page44/E2/Key/answerKey.png",
        inputSize: 200,
        titleImage: "",
        titleQuestion: [{ color: '#3F3478', num: '2', title: "Write yes or no." }],
        questionImage: [],
        questions: [
            {
                title: `
              <div >
                  <div><b>1</b> The boy's name is Khang.<u style='color: gray;'><i>yes</i></u></div>
                  <div><b>2</b> He gets up at seven o'clock. #</div>
                  <div><b>3</b> He walks to school. # </div>
                  <div><b>4</b> His dad goes to work by bus. # </div>
                  <div><b>5</b> He goes to bed at five o'clock. # </div>
                  <div><b>6</b> His dad goes home at five o'clock. # </div>
              </div>
            `,
                answer: ["no", "yes", "no", "no", "yes"],
            },
        ],
    },



}

export default json;